import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Frown, Search, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  const painPoints = [{
    icon: <Clock className="w-8 h-8 text-red-500" data-id="element-39" />,
    title: 'Domingos de ansiedad',
    text: 'Ese nudo en el estómago cuando cae la tarde y sentís que no tenés nada listo para el lunes.'
  }, {
    icon: <Search className="w-8 h-8 text-orange-500" data-id="element-40" />,
    title: 'El loop de Pinterest',
    text: "Entrás 'cinco minutos' y perdés horas guardando ideas sueltas que nunca terminás usando."
  }, {
    icon: <Frown className="w-8 h-8 text-purple-500" data-id="element-41" />,
    title: 'La culpa silenciosa',
    text: 'Sentir que estás improvisando y el miedo a que se note que no llegaste a planificar como querías.'
  }, {
    icon: <AlertCircle className="w-8 h-8 text-pink-500" data-id="element-42" />,
    title: 'Cansancio mental',
    text: "No es solo el cuerpo. Es la cabeza que no para de pensar '¿qué hago mañana?'."
  }];
  return <section className="py-20 bg-slate-50" data-id="element-43">
      <div className="container mx-auto px-4 md:px-6" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-46">
            Si sos docente de Nivel Inicial, dejame adivinar...
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-47">
            No te falta vocación. No te falta amor por los chicos.{' '}
            <br className="hidden md:block" data-id="element-48" />
            Lo que te falta —muchas veces— es{' '}
            <span className="font-bold text-slate-800" data-id="element-49">
              tiempo, tranquilidad y un sistema
            </span>
            .
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-50">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-51">
              <div className="bg-slate-50 w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-52">
                {point.icon}
              </div>
              <h3 className="text-lg font-bold text-slate-800 mb-2 text-center" data-id="element-53">
                {point.title}
              </h3>
              <p className="text-slate-600 text-center text-sm leading-relaxed" data-id="element-54">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-16 text-center max-w-2xl mx-auto bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-55">
          <p className="text-red-800 font-medium italic" data-id="element-56">
            "El problema no es que te falten ideas. Ideas hay por todos lados.
            El problema es que casi todo eso es suelto, incompleto y genérico."
          </p>
        </motion.div>
      </div>
    </section>;
}